import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from '@wix/yoshi-flow-editor';
import { UISref } from '@wix/tpa-router/react';

import { EGroupPartition } from '@wix/social-groups-serverless/dist/groups/types';

import { useController } from 'common/context/controller';

import { selectGroups } from 'store/selectors';

import { EmptyState } from 'wui/EmptyState';
import { Button } from 'wui/Button';

import { GroupGrid } from 'Groups/Widget/Layout/GridLayout/GroupGrid';

export function MyGroups() {
  const { groups$ } = useController();
  const { t } = useTranslation();

  const limit = 6;
  const state = useSelector(selectGroups(EGroupPartition.JOINED));

  return (
    <GroupGrid
      {...state}
      batchLength={limit}
      onRetry={handleRetry}
      onLoadMore={handleLoadMore}
      emptyState={
        <EmptyState
          data-type="partition-empty"
          title={t('groups-in-ma.my-groups.empty-state.header')}
          subtitle={t('groups-in-ma.my-groups.empty-state.text')}
          action={
            <UISref state="groups.list">
              <Button as="a">
                {t('groups-in-ma.my-groups.empty-state.action.label')}
              </Button>
            </UISref>
          }
        />
      }
    />
  );

  function handleRetry() {
    groups$.query({
      limit,
      offset: 0,
      namespace: EGroupPartition.JOINED,
      partition: EGroupPartition.JOINED,
    });
  }

  function handleLoadMore() {
    groups$.query({
      limit,
      offset: state.groups.length,
      namespace: EGroupPartition.JOINED,
      partition: EGroupPartition.JOINED,
    });
  }
}

MyGroups.displayName = 'MyGroups';
